export enum XenditFieldTypeEnum {
  card_number = 'card_number',
  expiry_date = 'expiry_date',
  cvn_number = 'cvn_number',
  card_holder_first_name = 'card_holder_first_name',
  card_holder_last_name = 'card_holder_last_name',
  card_holder_email = 'card_holder_email',
  card_holder_phone_number = 'card_holder_phone_number',
}
